import Request from './Request';

export interface IProfile {
    id: number;
    name: string;
    order: number;
}

class User {
    static GetAll = (): IProfile[] => { return Request.DoGet('profile/all') as unknown as IProfile[]; };
    static Get = (id: Number): IProfile => { return Request.DoGet('profile/' + id) as unknown as IProfile; };
}

export default User;